import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const CHANNEL_DETAILED_ORDER_STATUS_REQUEST: string =
  "OrderDetailedOrderStatusRequestChannel";

export interface IDetailedOrderStatusRequestService {
  request(id: String): Promise<CubiqTS.OrderDataImpl>;

  requestMediatedOrderDetails(id: String): Promise<CubiqTS.OrderDataImpl>;
}
